import React, {useState, useEffect, useContext} from "react"
import { api } from "../../../api/api";
import TranslationContext from "../../../context/TranslationContext"
import HotspotContext from "../../../context/HotspotContext"
import BuilderContext from "../../../context/BuilderContext"
import UserContext from "../../../context/UserContext"

import Button from "../../common/Button";
import {getErrorByStatus} from "../../Authentication/AuthContainer/helpers"
import LoginPage from "../LoginPage";
import { CheckOptionON, ContractOptionMask } from "../../../api/helper";

const AuthorizeAction = ({handlerBackBtn}) => {
    const {getTranslation} = useContext(TranslationContext)
    const {setApiWait, setAdModalShow, adBreak} = useContext(UserContext)
    const { options } = useContext(BuilderContext)
    const {request, setAwaitHotspot } = useContext(HotspotContext)

    const [login, setLogin ] = useState("")
    const [password, setPassword] = useState("")

    const [error, setError] = useState("") 
    const [errMessage, setErrMessage] = useState("") 
    
    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {setErrMessage(getTranslation(error))} else {setErrMessage(error)}  
        }
    },[getTranslation, error])

    useEffect(()=>{ 
        // проверяем включена ли AD\Polls => setAdModalShow(true)
        // console.log(adBreak,ad,polls)
        const ad = CheckOptionON(options, ContractOptionMask.ShowAd)
        const polls = CheckOptionON(options, ContractOptionMask.ShowPolls)
        if (!adBreak && (ad || polls)) {
            setAdModalShow(true)
            return
        }
        authHandler() 
    }, [adBreak])

    const authHandler = () => {
        setError("")
        setApiWait(true)
        api.getLoginRef(request).then(res => {
            
            if (res.data.status !== "invalid vendor") {
                setAwaitHotspot(true)
                window.location.assign(res.data.status)
            }
        }).catch(err => {
            // console.log(err.response.message)
            
            getErrorByStatus(err.response.status, setError, getTranslation)
        }).finally(() => setApiWait(false))
    }

    return(
        <>
            {
                (error !== "") ?
                <>
                    <p className="error" data-id_phrase={error}> {errMessage}</p>
                    <Button
                        onClick={handlerBackBtn}
                        text={"Назад"}
                        idPhrase={"back"}
                    />
                </>
                : <LoginPage />
            }
        </>
    )
}

export default AuthorizeAction